import { FormControl, FormControlLabel, Radio } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useContext } from "react";
import RhfCheck from "../../../../libs/rhf-mui/RhfCheck";
import Label from "../../../../libs/rhf-mui/ui/Label";
import { SpwkUtil } from "../../../dao/SpwkUtil";
import { UniOption } from "../../../dao/UniOption";
import { FrmSpwkQuestionnaire_Context } from "../index";
import UcOptionLabel from "../../../components/uni/UcOptionLabel";
import RhfErrorText from "../../../../libs/rhf-mui/RhfErrorText";
import { Member } from "../../../dao/Member";
import { useTranslation } from "react-i18next";

type Props = {
  option: UniOption;
  member: Member | null | undefined;
};

const UcOption = ({ option, member }: Props) => {
  const { t } = useTranslation();
  const mFrmSpwkQuestionnaire_Context = useContext(
    FrmSpwkQuestionnaire_Context
  );
  const label = (
    <UcOptionLabel
      uni_option={option}
      member={member}
      LangA={mFrmSpwkQuestionnaire_Context?.LangA ?? ""}
      LangB={mFrmSpwkQuestionnaire_Context?.LangB ?? ""}
    />
  );

  function Choice_radio_or_checkbox_or_textbox(option: UniOption) {
    if (option.OwnerQuestion?.kind === SpwkUtil.KIND_單選) {
      //針對B02, A98特定章節的單選題另外排版
      if (
        (option.form_guid === "_B02v0" &&
          option.question_chapter === SpwkUtil.CHAPTER_作業經歷) ||
        (option.form_guid === "_B02v0" &&
          option.question_chapter === SpwkUtil.CHAPTER_既往病史_噪音作業) ||
        (option.form_guid === "_B02v0" &&
          option.question_chapter === SpwkUtil.CHAPTER_自覺症狀_噪音作業) ||
        (option.form_guid === "_A98v0" &&
          option.question_chapter === SpwkUtil.CHAPTER_疲勞狀況)
      ) {
        return (
          <Grid
            item
            xs={12}
            sm={
              option.Inputs === undefined ? 3 : option.Inputs.length > 0 ? 6 : 3
            }
          >
            <FormControl>
              <FormControlLabel
                sx={{ alignItems: "flex-start" }}
                control={
                  <Radio
                    key={option.guid}
                    value={option.option_code}
                    sx={{ marginTop: option.HasInputs() ? "0px" : "0px" }}
                  />
                }
                label={label}
              />
            </FormControl>
          </Grid>
        );
      } else {
        return (
          <Grid item xs={12}>
            <FormControl>
              <FormControlLabel
                sx={{ alignItems: "flex-start" }}
                control={
                  <Radio
                    key={option.guid}
                    value={option.option_code}
                    sx={{ marginTop: option.HasInputs() ? "0px" : "0px" }}
                  />
                }
                label={label}
              />
            </FormControl>
          </Grid>
        );
      }
    } else if (option.OwnerQuestion?.kind === SpwkUtil.KIND_非選) {
      let visibility = option.visibility === "" ? "visible" : option.visibility;

      if (
        option.option_code === "目前從事" ||
        option.option_code === "曾經從事"
      ) {
        return (
          <Grid item xs={12} sm={12} md={4}>
            <Label key={option.guid}>{label}</Label>
          </Grid>
        );
      } else if (
        option.option_code === "過去1個月，平均每週工時" ||
        option.option_code === "過去6個月，平均每週工時" ||
        option.option_code === "平均每天睡眠"
      ) {
        return (
          <Grid item xs={12}>
            <Label key={option.guid}>{label}</Label>
          </Grid>
        );
      } else {
        return (
          <Grid item xs={12} sm={6} md={4}>
            <Label key={option.guid} sx={{ visibility: visibility }}>
              {label}
            </Label>
            {option.option_code === "AvgWorkHoursOfWeek" && (
              <>
                <Label br={true} style={{ color: "blue" }}>
                  <b>{t("常日班")}</b>
                  {t("=每週工時")}
                  <u>{t("40小時")}</u>
                </Label>
                <Label br={true} style={{ color: "blue" }}>
                  <b>{t("二二制班別")}</b>
                  {t("=每週工時")}
                  <u>{t("35小時")}</u>
                </Label>
                <Label style={{ color: "red" }}>
                  {t("♦請計入加班並扣除請假時數")}
                </Label>
              </>
            )}
          </Grid>
        );
      }
    } else {
      //多選
      if (option.question_kind === SpwkUtil.KIND_標題) {
        //標題的option<_無>不顯示
        return <> </>;
      } else {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl>
              <FormControlLabel
                sx={{ alignItems: "flex-start" }}
                control={
                  <RhfCheck
                    key={option.guid}
                    name={option.get_Option_RhfName()}
                    sx={{
                      marginTop: option.HasInputs() ? "0px" : "0px",
                    }}
                  />
                }
                label={label}
              />
            </FormControl>
            <RhfErrorText
              name={option.question_code + option.option_code}
              className="fs-4"
            />
          </Grid>
        );
      }
    }
  }

  return <>{Choice_radio_or_checkbox_or_textbox(option)}</>;
};

export default UcOption;
